import { supabase } from '../../../supabaseClient.js';

export const crearProductoBom = async (producto) => {

  const bomData = {
    producto_linea: producto.producto_linea,
    producto_insumo: producto.producto_insumo,
    cantidad: Number(producto.cantidad),
    unidad: producto.unidad || "UND",
    created_by: producto.usuario || "user default",
    created_at: new Date().toISOString(),
  };

  const { data, error } = await supabase
    .from("productos_bom")
    .insert([bomData])
    .select("*");

  if (error) {
    console.error("Error al insertar BOM:", error.message);
    return { success: false, error: error.message };
  }

  return { success: true, data };
};

export const obtenerProductosBom = async () => {
  try {
    const { data, error } = await supabase
      .from('productos_bom')
      .select('*')
  

    if (error) throw error;

    return { success: true, data };

  } catch (error) {
    console.error('Error al obtener los productos:', error.message);
    return { success: false, error: error.message };
  }
};